import { useCallback } from "react";
import { ListChecks } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import withRoleCheck from "components/hocs/withRoleCheck";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import NewCampaignStatusModal from "routes/campaign_status/components/NewCampaignStatusModal";
import CampaignService from "services/Campaign";
import {
  invalidateCampaignStatusesQuery,
  useCampaignStatusesTable,
} from "hooks/useCampaignStatusesTable";

export const CAMPAIGN_STATUSES_TABLE_CONSTANTS = {
  tableName: "campaign_statuses",
  queryKey: "campaign-statuses",
  exportTableName: null,
  className: null,
  header: "Campaign Status",
  headerIcon: ListChecks,
};

const NewCampaignStatusModalWithCheck = withRoleCheck(NewCampaignStatusModal, [
  ACL_RELATIONSHIPS.campaignStatuses.create,
]);

const CampaignStatusesTableV3 = () => {
  const { columns } = useCampaignStatusesTable();

  const fetchCampaignStatuses = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await CampaignService.getCampaignStatusesAsTable(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching campaign statuses:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      headerIcon={CAMPAIGN_STATUSES_TABLE_CONSTANTS.headerIcon}
      header={CAMPAIGN_STATUSES_TABLE_CONSTANTS.header}
      queryKey={CAMPAIGN_STATUSES_TABLE_CONSTANTS.queryKey}
      tableName={CAMPAIGN_STATUSES_TABLE_CONSTANTS.tableName}
      createButton={
        <NewCampaignStatusModalWithCheck
          fetchStatuses={invalidateCampaignStatusesQuery}
        />
      }
      fetchData={fetchCampaignStatuses}
      invalidateData={invalidateCampaignStatusesQuery}
      enableSettings
      enableSearch
    />
  );
};

export default CampaignStatusesTableV3;
